// utils/evidenciaPraceUtils.js

// Výpočet total: quantity × unitPrice
// Spätná kompatibilita: staré záznamy mohli mať 'minutes' alebo 'itemCount' namiesto 'quantity'
export function calculateEntryTotal(entry) {
  const qty = parseFloat(entry.quantity ?? entry.minutes ?? entry.itemCount) || 0;
  const price = parseFloat(entry.unitPrice) || 0;
  let total = qty * price;
  if (entry.service === 'Žiadosť o vrátenie DPH zo zahraničia') {
    total += 15;
  }
  return total;
}

// Súčet total pre zoznam záznamov
export function calculateTotal(entries) {
  return entries.reduce((sum, entry) => sum + entry.total, 0);
}

// Získanie filtrovaných záznamov podľa firmy, mesiaca a vyfakturovania
export function getFilteredEntries(entries, selectedCompany, filterMonth, showInvoiced) {
  return entries.filter(entry => {
    if (selectedCompany && entry.companyName !== selectedCompany) return false;
    // workPeriodFrom = nový field, workPeriod = starý field, date = fallback
    if (filterMonth && (entry.workPeriodFrom || entry.workPeriod || entry.date.slice(0, 7)) !== filterMonth) return false;
    if (showInvoiced === 'invoiced' && !entry.invoiced) return false;
    if (showInvoiced === 'not_invoiced' && entry.invoiced) return false;
    // 'all' = bez filtra
    return true;
  });
}

// Normalizácia textu (malé písmená, bez diakritiky, trim)
export function normalizeText(text) {
  if (!text) return '';
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Odstráni diakritiku (combining marks)
    .trim();
}

// Kapitalizácia názvu firmy (všetko veľkými písmenami)
export function capitalizeCompanyName(text) {
  if (!text) return '';
  return text.trim().toUpperCase();
}
